import {
  IHighRiskSupplementResponseDTO,
  IRiskSupplementImagesResponseDTO,
} from '@interfaces/highRiskSupplements';

import { RiskSupplementWarningType } from './riskSupplementWarningType';

export class HighRiskSupplement {
  id: number | null;

  name: string;

  category: string;

  company: string;

  normalizedCategory: string;

  statusDate: string;

  warningTypes: RiskSupplementWarningType[];

  image: IRiskSupplementImagesResponseDTO | null;

  constructor(dto: IHighRiskSupplementResponseDTO) {
    const data: IHighRiskSupplementResponseDTO =
      dto && typeof dto === 'object' ? dto : ({} as IHighRiskSupplementResponseDTO);
    this.id = typeof data.id === 'number' ? data.id : null;
    this.name = typeof data.name === 'string' ? data.name : '';
    this.category = typeof data.category === 'string' ? data.category : '';
    this.company = typeof data.company === 'string' ? data.company : '';
    this.normalizedCategory = this.category.toLowerCase().replaceAll(' ', '');
    this.statusDate = typeof data.statusDate === 'string' ? data.statusDate : '';
    this.warningTypes = Array.isArray(data.warningTypes)
      ? data.warningTypes.map(item => new RiskSupplementWarningType(item))
      : [];
    this.image = data.image
      ? {
          id: typeof data.image?.id === 'number' ? data.image.id : null,
          name: typeof data.image?.name === 'string' ? data.image.name : '',
          url: typeof data.image?.url === 'string' ? data.image?.url : '',
        }
      : null;
  }
}
